import { Box } from "@chakra-ui/react";
import TableReferralEarning from "./tableReferralEarning";

export default function ReferralEarning() {
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <TableReferralEarning />
    </Box>
  );
}
